import styled, { css } from 'styled-components'
import { Grid } from '@berlitz/globals/lib/components/layout'
import { transparentize } from 'polished'
import { H1 } from '@berlitz/globals/lib/components/typography'
import { TextAlign } from '@berlitz/globals'

export const FullWidthGrid = styled(Grid)`
  width: 100%;

  ${({ hasTopNav, theme }) =>
    hasTopNav &&
    css`
      @media (min-width: ${theme.breakpoints.md}) {
        margin-top: -80px;
      }
    `};
`

export const BannerH1 = styled(H1)`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.fontSize.xl};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    font-size: ${({ theme }) => theme.fontSize.xxxl};
  }
`

export const Banner = styled.section`
  background-color: ${({ theme }) => theme.colors.ui05};
  display: flex;
  flex-direction: column;
  min-height: ${({ theme }) => theme.layout.xxxl};
  position: relative;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    min-height: 512px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    height: ${({ isLarge }) => (isLarge ? '90vw' : '60vw')};
    max-height: ${({ isLarge }) => (isLarge ? '704px' : '512px')};
  }

  @media (min-width: 1900px) {
    max-height: ${({ isLarge }) => (isLarge ? '768px' : '600px')};
  }

  /* Dark overlay */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background-color: ${({ theme }) =>
      transparentize(0.4, theme.pageBanner.overlayColor)};
  }
`

export const Inner = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  position: relative;
  top: 0;
  width: 100%;
  z-index: 1;
  max-width: ${({ theme }) => theme.gridWidth};
  margin: 0 auto;
  padding: ${({ theme }) => theme.space.xl} 0;
`

export const Headings = styled.div`
  display: flex;
  flex-direction: ${({ flipText }) => (flipText ? 'column-reverse' : 'column')};
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 ${({ theme }) => theme.space.sm};
  }

  > * {
    &::first-letter {
      text-transform: capitalize;
    }
  }
`

export const BackgroundImage = styled.img`
  z-index: 0;
  display: block;
  position: absolute;
  object-fit: cover;
  /* Object Polyfill: https://github.com/fregante/object-fit-images */
  font-family: 'object-fit: cover;';
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
`
export const TextAlignBlock = styled(TextAlign)`
  display: block;
  padding: ${({ theme }) => theme.space.xl} 0;
`
